import { USER_EVENTS_PUBLIC_ENDPOINT } from '@app/pages/api/constants';
import { ObjectValues } from 'types';

const PERSONALIZATION_EVENT_NAME = {
  UserViewedProduct: 'user-viewed-product',
} as const;

type PersonalizationEventName = ObjectValues<typeof PERSONALIZATION_EVENT_NAME>;

interface TriggerPersonalizationEventParams {
  workId: string;
  inventoryItemId: string;
  eventName: PersonalizationEventName;
}

export const triggerPersonalizationEvent = ({
  workId,
  inventoryItemId,
  eventName,
}: TriggerPersonalizationEventParams) => {
  fetch(USER_EVENTS_PUBLIC_ENDPOINT, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      event: {
        name: eventName,
        topic: 'user-events',
        message: {
          workId,
          source: 'web/works',
          inventoryItemId,
        },
      },
    }),
  });
};
